import styled from 'styled-components';
import { Container, SECTION_PADDING } from '../styles/layout';

export const InnerSection = styled.section`
  padding: 40px 0 ${SECTION_PADDING};
`;

export const InnerContainer = Container;

export const InnerCard = styled.div`
  background: linear-gradient(145deg, rgba(239, 244, 249, 0.7), rgba(223, 231, 240, 0.7));
  border: 1px solid #cfd9e4;
  border-radius: 18px;
  padding: 36px 32px;
  box-shadow: 0 20px 40px rgba(34, 50, 70, 0.12);
`;

export const PageTitle = styled.h2`
  color: #1f2b3a;
  margin: 0 0 16px;
`;

export const SectionTitle = styled.h3`
  color: #1f2b3a;
  margin: 28px 0 14px;
`;

export const Paragraph = styled.p`
  font-size: 16px;
  color: #4a5a6b;
  line-height: 1.7;
  margin: 0 0 16px;
`;

export const Emphasis = styled.span`
  font-weight: 600;
  color: #1f2b3a;
`;

export const BulletList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 0 18px;
  display: grid;
  gap: 10px;
`;

export const BulletItem = styled.li`
  position: relative;
  padding-left: 18px;
  color: #4a5a6b;
  line-height: 1.6;

  &::before {
    content: '\\2022';
    position: absolute;
    left: 0;
    color: #1c3650;
  }
`;

export const OrderedList = styled.ol`
  margin: 0 0 18px;
  padding-left: 20px;
  color: #4a5a6b;
  line-height: 1.6;
`;

export const OrderedItem = styled.li`
  margin-bottom: 10px;
`;

export const TextLink = styled.a`
  color: #1f2b3a;
  font-weight: 600;
  text-decoration: none;
  border-bottom: 1px solid rgba(31, 43, 58, 0.25);

  &:hover {
    color: #0f1c2d;
    border-bottom-color: rgba(15, 28, 45, 0.55);
  }
`;
